import { Stack } from 'expo-router';
import React from 'react';

export default function TellingBattlePlanLayout() {
  return (
    <Stack>
      <Stack.Screen name="index" />
      <Stack.Screen name="[pollingStationId]" />
    </Stack>
  );
}
